import { actions } from '../actions/Roles';

const initialState = {
  loading: false,
  data: null,
};

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET:
      return {
        ...state,
        loading: true,
      };
    case actions.PUT:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case actions.RESET:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
};

export default rolesReducer;
